import { TApplicationState } from '../../types/redux';

export function selectBlackFridayPromoDatesText(state: TApplicationState) {
  return state.blackFriday.promoDatesText;
}
